module.exports = __webpack_public_path__ + "img/CN.01645c0f.png";